import { Catalog, CatalogSkeleton } from 'client/components/Catalog';
import { RepositoryCatalogItem, type RepositoryCatalogRepositoryBranch } from './RepositoryCatalogItem';

export interface RepositoryCatalogProps {
  projectID: number | null | undefined;
  repositoryRef: string | null;
  onChangeBranch?: (branch: RepositoryCatalogRepositoryBranch | null) => void;
}

export const RepositoryCatalog = ({ projectID, repositoryRef, onChangeBranch }: RepositoryCatalogProps) => {
  const isLoadingOrEmpty = !projectID;

  if (isLoadingOrEmpty) return <CatalogSkeleton numberOfItems={1} />;

  return (
    <Catalog items={[]}>
      <RepositoryCatalogItem projectID={projectID} repositoryRef={repositoryRef} onChangeBranch={onChangeBranch} />
    </Catalog>
  );
};
